import browserSupported from './browserSupported'
import checkout from './checkout'
import auth from './auth'

export default {
  auth,
  checkout,
  browserSupported
}
